import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const DocsNode = z.strictObject({
    name: z.string(),
    path: z.string(),
    type: z.enum(['file', 'folder']),
    children: z.lazy(() => DocsNode.array()),
});
const GetTreeResponse = z.strictObject({ tree: DocsNode.array() });
const GetContentQuery = z.strictObject({ path: z.string() });
const GetContentResponse = z.strictObject({ content: z.string() });
const c = initContract();
export const docsapiContract = c.router({
    getTree: {
        method: 'GET',
        path: '/tree',
        responses: {
            200: GetTreeResponse,
        },
    },
    getContent: {
        method: 'GET',
        path: '/content',
        query: GetContentQuery,
        responses: {
            200: GetContentResponse,
            400: z.strictObject({ message: z.string() }),
            404: z.strictObject({ message: z.string() }),
        },
    },
}, {
    strictStatusCodes: true,
    pathPrefix: '/docs',
});
